import classNames from 'classnames';
import React from 'react';

import { WebsiteLink } from 'src/components/common/website-link';

import * as styles from './link-dropdown.module.scss';

type LinkDropdownProps = {
  links: readonly Queries.LinkDropdownCtaDropdownOptions[];
  showingMobileNav?: boolean;
  onClick: () => void;
};

const LinkDropdown = ({ links, showingMobileNav, onClick }: LinkDropdownProps) => (
  <div className={classNames('relative', styles.dropdownWrapper)}>
    <div className={classNames(styles.dropdownContainer, showingMobileNav && styles.mobileNav)}>
      <div className="flex flex-column">
        {links.map(({ link, displayText }, index) => (
          <WebsiteLink to={link} className={styles.link} key={index} handleClick={onClick}>
            {displayText}
          </WebsiteLink>
        ))}
      </div>
    </div>
  </div>
);

export default LinkDropdown;
